import { render, staticRenderFns } from "./M2hWeFitterChallengeWidget.vue?vue&type=template&id=64e35da8&scoped=true&"
import script from "./M2hWeFitterChallengeWidget.vue?vue&type=script&lang=js&"
export * from "./M2hWeFitterChallengeWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e35da8",
  null
  
)

export default component.exports